import { ForceLayoutCollisionStrategy } from './ForceLayoutCollision';

export const FLOATING_PANEL_STRATEGY_MAP = {
  forceLayout: ForceLayoutCollisionStrategy,
} as const;
